<template>
  <div class="about-me-page">
    <!-- Page banner -->
    <Banner main-title="about me"
            main-text="Core values, principles"
            italic-text="and experience"
            typewriter-id="AboutMe"
            banner-class="banner-red"
            :typewriter-delay="150"
            :has-scroll-indicator="true"
            class="left"/>

    <!-- Core values and principles-->
    <ColumnBoxes :columns="coreValues" class="core-values-wrapper"/>

    <!-- Skills -->
    <h2 class="section-title">Skills</h2>
    <ResumeSkills class="resume-skills"/>

    <!--    <div class="more-about-me">-->
    <!--      <p class="more-text">My professional and personal life mainly revolve around two basic beliefs -amongst-->
    <!--        others; <br/>-->
    <!--      honesty is the best policy and practice makes perfect. I am always trying to improve and practice my skills as a-->
    <!--      front-end-->
    <!--      developer, while staying true to myself and being honest.</p>-->
    <!--    </div>-->

    <!-- Experience -->
    <h2 class="section-title">Profession & academic experience</h2>
    <ResumeTimeline/>
  </div>
</template>

<script>
import Banner from "@/components/v2/Banner";
import ColumnBoxes from "@/components/partials/aboutMe/ColumnBoxes";
import ColumnBox from "@/models/ui/ColumnBox";
import ResumeSkills from "@/components/partials/resume/ResumeSkills";
import ResumeTimeline from "@/components/partials/resume/ResumeTimeline";
import {userVisitedAboutMe} from "@/setup/firebase/firebaseAnalytics";

export default {
  name: "AboutMe",
  components: {
    ResumeTimeline,
    ResumeSkills,
    ColumnBoxes,
    Banner
  },
  data: () => ({
    coreValues: [
      new ColumnBox(33, 'Honesty', 'is the best policy', 'I never forget where I am coming from and who I am. What makes a developer professional is his principles, values and ethics.'),
      new ColumnBox(23, 'Practice', 'makes perfect', 'I am always trying to improve and practice my skills as a front-end developer. Front-end development is my passion and whenever I have free time I love working on my portfolio.'),
    ]
  }),
  mounted() {
    userVisitedAboutMe();
  },
  metaInfo: {
    title: 'Pertsilis',
    titleTemplate: '%s | About me.',
    meta: [{
      name: 'description',
      content: 'Front-end web developer in the Netherlands, with experience in building web applications and PWAs, using Vue.js and JavaScript.'
    }]
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/base.mixins";
@import "~@/assets/css/base.variables";
@import "~@/assets/css/base.fonts";

.about-me-page {
}

/** Core values and principles **/
.core-values-wrapper {
  padding: 0 20px;
  margin-top: 35px;
}

/** Resume **/
.resume-skills {
  padding: 0 20px;
}

/** More about me  **/
.more-about-me {
  background-color: var(--blue-main);
  padding: 20px 20px;
  height: 50px;

  .more-text {
    color: white;
    font-weight: 900;
  }
}

/** Other **/
.section-title {
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 5px;
  margin-top: 60px;
  margin-bottom: 15px;
  padding: 0 20px;
  text-transform: uppercase;
}

@media screen and (min-width: $screen-md) {
  .about-me-page {
  }

  /** Core values and principles **/
  .core-values-wrapper {
    margin-top: 45px;
    padding: 0 10%;
  }

  /** More about me  **/
  .more-about-me {
    padding: 20px 10%;

    .more-text {
    }
  }

  /** Resume **/
  .resume-skills {
    padding: 0 10%;
  }

  /** Other **/
  .section-title {
    font-size: 28px;
    padding: 0 10%;
  }
}
</style>
